import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowRight, Sparkles } from "lucide-react";
import { api } from "../lib/api";
import { SEO } from "../components/SEO";
import { FadeUp } from "../components/motion";
import { useLang } from "../i18n/LanguageContext";

// Index des pages d'atterrissage par occasion (SEO : tournoi de hockey, gala…)
export default function Occasions() {
  const { lang, t, ts } = useLang();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/occasions").then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);

  return (
    <div className="pt-32 pb-28 max-w-7xl mx-auto px-6 lg:px-10" data-testid="occasions-page">
      <SEO
        title={`${ts("occasions.title")} | Mr Trophée`}
        description={ts("occasions.intro")}
        path="/occasions"
      />
      <FadeUp>
        <p className="text-gold tracking-[0.3em] uppercase text-xs mb-4 flex items-center gap-2">
          <Sparkles className="w-4 h-4" /> {t("occasions.kicker")}
        </p>
        <h1 className="font-serif text-4xl md:text-5xl leading-tight mb-4" data-testid="occasions-title">{t("occasions.title")}</h1>
        <p className="text-ivory/60 text-sm leading-relaxed max-w-2xl mb-12">{t("occasions.intro")}</p>
      </FadeUp>

      {!items ? (
        <div className="flex items-center justify-center py-32"><Loader2 className="w-8 h-8 animate-spin text-gold" /></div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((o, i) => {
            const title = lang === "en" ? o.title_en : o.title_fr;
            const desc = lang === "en" ? o.desc_en : o.desc_fr;
            return (
              <FadeUp key={o.slug} delay={Math.min(i, 5) * 0.06}>
                <Link to={`/occasions/${o.slug}`} data-testid={`occasion-card-${o.slug}`}
                  className="group block bg-surface border border-ivory/10 rounded-xl overflow-hidden hover:border-gold/50 transition-colors duration-300 h-full">
                  <div className="bg-white aspect-[16/10] flex items-center justify-center p-6">
                    <img src={o.image} alt={title} loading="lazy"
                      className="max-h-full max-w-full object-contain group-hover:scale-105 transition-transform duration-500" />
                  </div>
                  <div className="p-6">
                    <h2 className="font-serif text-xl leading-snug mb-2 group-hover:text-gold transition-colors duration-300">{title}</h2>
                    <p className="text-xs text-ivory/60 leading-relaxed line-clamp-3 mb-4">{desc}</p>
                    <span className="inline-flex items-center gap-2 text-gold text-xs uppercase tracking-widest">
                      {t("occasions.view")} <ArrowRight className="w-3.5 h-3.5" />
                    </span>
                  </div>
                </Link>
              </FadeUp>
            );
          })}
        </div>
      )}
    </div>
  );
}
